import { CheckoutSessionStatus, LoanDesistReason, LoanStatusExternal } from '@nemuru-eng/js-api-client';

import { FunnelStageStep } from '../types/funnelStageStep';

export const ALLOWED_ORDER_STATUSES_FOR_MULTI_SELECT_FILTER = [
  LoanStatusExternal.INITIAL,
  LoanStatusExternal.REQUESTED,
  // LoanStatusExternal.ON_HOLD,
  LoanStatusExternal.APPROVED,
  LoanStatusExternal.CONFIRMED,
  LoanStatusExternal.CAPTURED,
  LoanStatusExternal.PAID,
  LoanStatusExternal.DENIED,
  LoanStatusExternal.CANCELLED,
  LoanStatusExternal.DESISTED,
  LoanStatusExternal.EXPIRED,
];

export const ORDER_STATUS_DEFINITIONS = {
  [LoanStatusExternal.INITIAL]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_APPLICATION_STARTED',
    colorPaletteName: 'default',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.STARTED,
  },
  [CheckoutSessionStatus.CHALLENGE]: {
    DESCRIPTION_T_ID: 'PENDING',
    colorPaletteName: 'warning',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.CHALLENGE,
  },
  [LoanStatusExternal.ON_HOLD]: {
    DESCRIPTION_T_ID: 'OTP_PENDING',
    colorPaletteName: 'info',
    colorType: 'dark',
    SECTION_T_ID: FunnelStageStep.STARTED,
  },
  [LoanStatusExternal.REQUESTED]: {
    DESCRIPTION_T_ID: 'PENDING',
    colorPaletteName: 'info',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.REQUESTED,
  },
  [LoanStatusExternal.APPROVED]: {
    DESCRIPTION_T_ID: 'CONFIRMATION_PENDING',
    colorPaletteName: 'success',
    colorType: 'dark',
    SECTION_T_ID: FunnelStageStep.APPROVED,
  },
  [LoanStatusExternal.CONFIRMED]: {
    DESCRIPTION_T_ID: 'CAPTURE_PENDING',
    colorPaletteName: 'success',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.CONFIRMED,
  },
  [LoanStatusExternal.CAPTURED]: {
    DESCRIPTION_T_ID: 'CAPTURED',
    colorPaletteName: 'success',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.CONFIRMED,
  },
  [LoanStatusExternal.PAID]: {
    DESCRIPTION_T_ID: 'APPLICATION_COMPLETED',
    colorPaletteName: 'success',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.PAID,
  },
  [LoanStatusExternal.DESISTED]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_DESISTED',
    colorPaletteName: 'minor',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.DESISTED,
  },
  [LoanStatusExternal.EXPIRED]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_ORDER_EXPIRED',
    colorPaletteName: 'minor',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.EXPIRED,
  },
  [LoanStatusExternal.CANCELLED]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_CANCELLED',
    colorPaletteName: 'minor',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.CANCELLED,
  },
  [LoanStatusExternal.DENIED]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_DENIED',
    colorPaletteName: 'error',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.DENIED,
  },
};

export const loanStatusExternalToDescriptionMap = ({
  loanStatusExternal,
  desistReason = undefined,
}: {
  loanStatusExternal: LoanStatusExternal;
  desistReason?: LoanDesistReason | null;
}) => {
  switch (loanStatusExternal) {
    case LoanStatusExternal.DESISTED:
      return desistReason;
    default:
      return ORDER_STATUS_DEFINITIONS[loanStatusExternal].DESCRIPTION_T_ID;
  }
};
